import { HelpPage } from "@/interface/pages/help-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/help")({
  component: RouteComponent,
});

function RouteComponent() {
  return <HelpPage />;
}
